import { preview } from '@/components/form/preview'
import { useTexts } from './../../hooks/useTexts'
import { Edit } from '@workwave-tidal/core/icons'

interface Props {
  onEdit: () => void
}

export function Header(props: Props) {
  const texts = useTexts()

  return (
    <preview.Header
      title={texts.headerTitle}
      subtitle={texts.headerDescription}
      testId="preferences-view-header"
    >
      <preview.ActionBar>
        <preview.ActionBarItem
          icon={<Edit />}
          onClick={props.onEdit}
          label={texts.edit}
          disableWhenReadOnly
          tooltip={texts.edit}
          testId="preferences-view__edit"
          data-trackid="preferences-view__edit"
        />
      </preview.ActionBar>
    </preview.Header>
  )
}
